import "../../styles/reset.css";
import "./noteForm.css";
import NoteControls from "../noteControls/NoteControls";
import React from "react";


class NoteForm extends React.Component {
    render() {
        const { title, text, color } = this.props.newNote;

        return (
            <form className="new-note"
                  onInput={(e) => this.props.handleInput(e)}>
                <textarea rows="1"
                          className="new-note__title"
                          placeholder="Title"
                          required value={title}/>
                {this.props.appearances !== "DEFAULT" &&
                <React.Fragment>
                    <textarea rows="3" className="new-note__text new-note__text_size_s"
                              placeholder="Take a note..."
                              required value={text}/>
                    <NoteControls appearances={this.props.appearances}
                                  color={color}
                                  handleClickColor={this.props.handleClickColor}
                                  handleDelete={this.props.handleDelete}
                                  handleReset={this.props.handleReset}
                                  handleSubmit={this.props.handleSubmit}/>
                </React.Fragment>}
            </form>
        );
    }
}

export default NoteForm;
